import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import Card from './card';
import icons from '../../../assets/icons';
import './styles.scss';

const selectableFeatures = ['POS', 'WEB_ANALYTICS', 'SCREEN_TO_STORE'];

export const normalizeFeatures = features => {
  const featureList = Array.isArray(features) ? features : features ? [features] : [];

  return [
    ...new Set(
      featureList
        .map(feature => (feature === 'ECOMMERCE' ? 'WEB_ANALYTICS' : feature))
        .filter(feature => selectableFeatures.includes(feature))
    )
  ];
};

const options = [
  {
    label: 'Point Of Sale',
    icon: icons.posMachine,
    value: 'POS',
    tooltip: 'Input sales data to measure revenue uplift inside physical or online stores.'
  },
  {
    label: 'Web Analytics',
    icon: icons.webAnalytics,
    value: 'WEB_ANALYTICS',
    tooltip: 'Connect website to track overall traffic and direct attribution from screen to URL.'
  },
  {
    label: 'Screen-to-Store',
    icon: icons.store,
    value: 'SCREEN_TO_STORE',
    tooltip: 'Geofence physical stores to attribute store traffic to campaign exposure.'
  },
  {
    label: 'Keyword Study - Coming soon',
    icon: icons.keyword,
    value: 'KEYWORD_STUDY',
    disabled: true,
    tooltip:
      'Input words and phrases, key to each campaign so our tool can track search volume variance across your locations.'
  }
];

const Features = ({ portal, features, onSelection }) => {
  const selectedFeatures = normalizeFeatures(features ?? portal?.activeFeatures ?? portal?.features ?? portal?.feature);

  const handleSelection = (feature, selected) => {
    const nextFeatures = selected
      ? [...new Set([...selectedFeatures, feature])]
      : selectedFeatures.filter(selectedFeature => selectedFeature !== feature);

    onSelection(nextFeatures);
  };

  return (
    <>
      <div className="feature-options" role="group" aria-label="Portal features">
        {options.map(option => {
          const selected = selectedFeatures.includes(option.value);
          const optionId = `feature-option-${option.value}`;

          return (
            <div key={option.value} id={optionId} className="feature-option-tooltip">
              <label className={`feature-option${selected ? ' selected' : ''}${option.disabled ? ' disabled' : ''}`}>
                <input
                  type="checkbox"
                  checked={selected}
                  disabled={option.disabled}
                  onChange={event => handleSelection(option.value, event.target.checked)}
                />
                <Card label={option.label} icon={option.icon} disabled={option.disabled} />
              </label>
              <UncontrolledTooltip placement="bottom" target={optionId} popperClassName="feature-tooltip">
                {option.tooltip}
              </UncontrolledTooltip>
            </div>
          );
        })}
      </div>
      <div className="coming-soon">
        <p style={{ fontSize: '14px' }}>
          NOTE: These tools are available to be activated per campaign when needed. When activated it will generate a
          fee per month in order to function
        </p>
      </div>
    </>
  );
};

export default Features;
